(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klaar-home-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('klaar-editorial')) {
    customElements.define('klaar-editorial', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.k4-quickbar');
        this.hero = this.querySelector('.k4-hero');
        this.formats = this.querySelector('.k4-formats');
        this.finalSection = this.querySelector('.k4-final');
        this.abortController = new AbortController();
        this.updateBar = () => {
          const hero = this.hero.getBoundingClientRect();
          const formats = this.formats.getBoundingClientRect();
          const final = this.finalSection.getBoundingClientRect();
          const previewBar = document.querySelector('#PBarNextFrame');
          const previewRect = previewBar?.getBoundingClientRect();
          const previewVisible = previewRect && previewRect.height > 0 && previewRect.top < window.innerHeight && previewRect.bottom > 0;
          this.bar.style.bottom = previewVisible ? `${window.innerHeight - previewRect.top + 12}px` : '';
          this.bar.hidden = hero.bottom > 0 || final.top < window.innerHeight || (formats.top < window.innerHeight * .6 && formats.bottom > window.innerHeight * .4);
        };
        this.schedule = () => {
          if (this.pendingFrame) return;
          this.pendingFrame = requestAnimationFrame(() => { this.pendingFrame = 0; this.updateBar(); });
        };
        window.addEventListener('scroll', this.schedule, { passive: true, signal: this.abortController.signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal: this.abortController.signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this);
        this.updateBar();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.pendingFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaar-home-premium"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-klaar-home]').forEach((root)=>{root.querySelectorAll('[data-view-button]').forEach((button)=>{button.addEventListener('click',()=>{const view=button.dataset.viewButton;root.querySelectorAll('[data-view-button]').forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',active?'true':'false')});root.querySelectorAll('[data-view]').forEach((image)=>image.classList.toggle('is-active',image.dataset.view===view))})});root.querySelectorAll('[data-format-tab]').forEach((tab)=>{tab.addEventListener('click',()=>{const index=tab.dataset.formatTab;root.querySelectorAll('[data-format-tab]').forEach((item)=>{const active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false')});root.querySelectorAll('[data-format-panel]').forEach((panel)=>{const active=panel.dataset.formatPanel===index;panel.classList.toggle('is-active',active);panel.hidden=!active})})});const reveals=root.querySelectorAll('[data-reveal]');if('IntersectionObserver'in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){const observer=new IntersectionObserver((entries)=>{entries.forEach((entry)=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.12});reveals.forEach((item)=>observer.observe(item))}else{reveals.forEach((item)=>item.classList.add('is-visible'))}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
